<template>
  <div class="home-box">
    <PageTitle :title="'Project Submission Form'"></PageTitle>
    <v-row align="center">
      <v-overlay :value="loading" :opacity="1" :color="'#FFFFFF'">
        <v-progress-circular color="#FFB300" indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <div class="col-md-12 home-tabs-body">
        <Step01 v-if="step == 1 && !editMode"></Step01>
        <Step01Edit :uuid="uuid" v-if="step == 1 && editMode && uuid != null"></Step01Edit>
        <Step02 v-if="step == 2 && uuid != null" :uuid="uuid"></Step02>
        <Step03 v-if="step == 3 && uuid != null" :uuid="uuid"></Step03>
        <Step04 v-if="step == 4 && uuid != null" :uuid="uuid"></Step04>
        <Step05 v-if="step == 5 && uuid != null" :uuid="uuid"></Step05>
        <Step06 v-if="step == 6 && uuid != null" :uuid="uuid"></Step06>
        <Success v-if="step === 8 && uuid != null"></Success>
      </div>
    </v-row>
  </div>
</template>

<script>
import Step01Edit from "@/components/service-projects/forms/create/Step01Edit";
import Step01 from "@/components/service-projects/forms/create/Step01";
import Step02 from "@/components/service-projects/forms/create/Step02";
import Step03 from "@/components/service-projects/forms/create/Step03";
import Step04 from "@/components/service-projects/forms/create/Step04";
import Step05 from "@/components/service-projects/forms/create/Step05";
import Success from "@/components/service-projects/forms/create/Success";
import PageTitle from "@/components/shared/PageTitle";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "Projects",
  components: {
    Step01,
    Step01Edit,
    Step02,
    Step03,
    Step04,
    Step05,
    Success,
    PageTitle,
  },
  data: function () {
    return {
      step: localStorage.getItem('service_project_step') || 1,
      uuid: localStorage.getItem('service_project_uuid') || null,
      editMode: false,
    };
  },
  computed: {
    ...mapGetters({
      loading: "loading",
      profile: "profile",
    }),
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
    localStorage.removeItem('service_project_uuid');
    localStorage.removeItem('service_project_step');
    localStorage.removeItem('service_project_edit');
    this.editMode = false;
    this.uuid = null;

    if (this.$route.params.uuid && this.$route.params.uuid !== 'undefined') {
      this.uuid = this.$route.params.uuid;
      this.step = this.$route.params.step;
      this.editMode = true;
      localStorage.setItem('service_project_uuid', this.uuid);
      localStorage.setItem('service_project_step', this.step);
      localStorage.setItem('service_project_edit', this.editMode);
    } else {
      localStorage.setItem('service_project_uuid', null);
      localStorage.setItem('service_project_step', 1);
      localStorage.setItem('service_project_edit', false);
      this.uuid = null;
      this.step = 1;
      this.editMode = false;
    }

  },

  watch: {
    $route() {
      this.uuid = null;
      this.step = 1;

      if (this.$route.params.uuid && this.$route.params.uuid !== 'undefined') {
        this.uuid = this.$route.params.uuid;
        this.step = this.$route.params.step;
      }

      localStorage.setItem('service_project_uuid', this.uuid);
      localStorage.setItem('service_project_step', this.step);
    }
  }
};
</script>
